module.exports = __webpack_public_path__ + "img/31_22.57eea1bd.png";